import { apiClient } from 'client/core/network/apiClient';
import { PaginatedResult } from 'common/dto/shared/PaginatedResult';
import { ICategoryResult, IProcedure } from 'common/schema/Procedure';
import { IProcedureDto, IProceduresQueryDto } from 'common/dto/ProcedureDto';
import { IProcedureUpdateDto } from 'common/dto/ProcedureUpdateDto';

export const ProcedureApi = {
  // Frontend (projections)
  frontend: {
    find: (opts: { id: number }) =>
      apiClient.get<IProcedure>(`/procedures/projections/frontend/${opts.id}`),
    list: (opts: { query: IProceduresQueryDto }) =>
      apiClient.get<PaginatedResult<IProcedure>>(
        `/procedures/projections/frontend`,
        { params: opts.query }
      ),

    findCategories: (opts: {}) =>
      apiClient.get<ICategoryResult[]>(
        `/procedures/projections/frontend/relationships/categories/`
      )
  },

  // Backend
  find: (opts: { id: number }) =>
    apiClient.get<IProcedure>(`/procedures/${opts.id}`),
  create: (opts: { input: IProcedureDto }) =>
    apiClient.post<IProcedure>(`/procedures`, opts.input),
  update: (opts: { id: number; input: IProcedureDto }) =>
    apiClient.put<IProcedure>(`/procedures/${opts.id}`, opts.input),
  updatePublished: (opts: { id: number; input: IProcedureUpdateDto }) =>
    apiClient.put<IProcedure>(`/procedures/published/${opts.id}`, opts.input),
  delete: (opts: { id: number }) => apiClient.delete(`/procedures/${opts.id}`),
  list: (opts: { query: IProceduresQueryDto }) =>
    apiClient.get<PaginatedResult<IProcedure>>(`/procedures`, {
      params: opts.query
    }),

  // Categorie
  findCategories: (opts: {}) =>
    apiClient.get<ICategoryResult[]>(`/procedures/relationships/categories/`),

  // Allegati
  uploadAttachment: (opts: { data: FormData }) =>
    apiClient.post<any>(`/procedure-attachments`, opts.data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),

  // Utenti abilitati alla visualizzazione delle domande
  uploadEnabledUsers: (opts: { id: number; data: FormData }) =>
    apiClient.post<any>(`/procedures/${opts.id}/enabled-users`, opts.data),

  // Count utenti abilitati alla visualizzazione della domanda
  countEnabledUsers: (opts: { id: number }) =>
    apiClient.get<number>(`/procedures/${opts.id}/enabled-users/count`),

  // Azioni
  publish: (opts: { id: number }) =>
    apiClient.post(`/procedures/${opts.id}/actions/publish`),
  suspend: (opts: { id: number }) =>
    apiClient.post(`/procedures/${opts.id}/actions/suspend`),
  unsuspend: (opts: { id: number }) =>
    apiClient.post(`/procedures/${opts.id}/actions/unsuspend`),
  cancel: (opts: { id: number }) =>
    apiClient.post(`/procedures/${opts.id}/actions/cancel`),
  redraft: (opts: { id: number }) =>
    apiClient.post(`/procedures/${opts.id}/actions/redraft`),
  extend: (opts: { id: number; expiresAt: Date | null | undefined }) =>
    apiClient.post(`/procedures/${opts.id}/actions/extend`, {
      expiresAt: opts.expiresAt
    }),
  toTest: (opts: { id: number }) =>
    apiClient.post(`/procedures/${opts.id}/actions/test`),

  // Funzioni per centralizzare e recuperare i link
  links: {
    exportExcel: (procedureId: number) => {
      return `/procedures/${procedureId}/exports`;
    }
  }
};
